import React, { FC } from 'react';
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';
import ErrorBoundary from '@/components/error-boundary';
import Index from '@/pages/index';

const Routes: FC<Record<string, unknown>> = () => {
  const routes: RouteObject[] = [
    {
      path: '/frontend-portal',
      element: <Index />,
    },
    {
      path: '/',
      element: <Index />,
    },
  ];

  const addErrorBoundary = (routeList: RouteObject[]): RouteObject[] => routeList.map((route) => {
    const newRoute = route;
    newRoute.errorElement = <ErrorBoundary />;
    if (newRoute.children) {
      newRoute.children = addErrorBoundary(route.children);
    }
    return newRoute;
  });

  const withErrorBoundaryRoutes = addErrorBoundary(routes);

  const router = createBrowserRouter(withErrorBoundaryRoutes);

  return <RouterProvider router={router} />;
};

export default Routes;
